import PropTypes from "prop-types";
import { Fragment, useEffect } from "react";
import HeaderOne from "../wrappers/header/HeaderOne";
import FooterOne from "../wrappers/footer/FooterOne";
import ScrollToTop from "../components/scroll-to-top";
import { useTranslation } from "react-i18next";

const LayoutOne = ({
  children,
  headerContainerClass,
  headerTop,
  headerPaddingClass,
  headerPositionClass,
}) => {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.style.direction =
      localStorage.getItem("i18nextLng") == "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute(
      "dir",
      localStorage.getItem("i18nextLng") == "ar" ? "rtl" : "ltr"
    );
  }, [i18n.language]);

  return (
    <Fragment>
      <HeaderOne
        layout={headerContainerClass}
        headerPaddingClass={headerPaddingClass}
        headerPositionClass={headerPositionClass}
      />
      {children}
      <FooterOne
        footerTopSpaceTopClass="pt-80"
        spaceBottomClass="pb-25"
        footerLogo="/assets/img/logo/logo-2.png"
        backgroundColorClass="bg-gray"
        spaceTopClass="pt-70"
        spaceBottomClass="pb-0"
      />
      <ScrollToTop />
    </Fragment>
  );
};

LayoutOne.propTypes = {
  children: PropTypes.node,
  headerContainerClass: PropTypes.string,
  headerPaddingClass: PropTypes.string,
  headerPositionClass: PropTypes.string,
  headerTop: PropTypes.string,
};

export default LayoutOne;
